module.exports = __webpack_public_path__ + "img/zzybx.980ac978.png";